import { Injectable }                                                     from '@angular/core';
import { ActivatedRouteSnapshot, CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';

// L'editorialTimestamp n'a de sens que pour la newsletter sur laquelle il a été posé, mais la plupart des navigations
// utilisent queryParamsHandling: 'preserve' (pour conserver l'engineId) et l'emportent vers une autre newsletter.
// On ne le conserve donc qu'à la première navigation (lien partagé) ou si la source reste la même.
//
// CanMatch (et non CanActivate) : la redirection doit intervenir avant les canDeactivate, sinon ceux-ci seraient
// rejoués par la navigation de redirection (EditCampaignContentComponent bloque un second appel).
@Injectable()
export class ClearStaleEditorialTimestamp implements CanMatch {

  constructor(private router: Router) { }

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    const targetUrl = this.router.currentNavigation()?.extractedUrl;
    if (!targetUrl || targetUrl.queryParams['editorialTimestamp'] == null || !this.router.navigated) return true;

    // Pendant la phase de matching, routerState contient encore l'état de la page que l'on quitte.
    // segments = ['newsletters', ':source', ...]
    const targetSource = segments[1]?.path;
    const currentSource = this.deepestParam(this.router.routerState.snapshot.root, 'source');
    if (targetSource && targetSource === currentSource) return true;

    const tree = this.router.parseUrl(this.router.serializeUrl(targetUrl));
    delete tree.queryParams['editorialTimestamp'];
    return tree;
  }

  private deepestParam(snapshot: ActivatedRouteSnapshot, key: string): string | undefined {
    let value: string | undefined;
    for (let s: ActivatedRouteSnapshot | null = snapshot; s; s = s.firstChild) value = s.params[key] ?? value;
    return value;
  }

}
